import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import * as echarts from 'echarts';
// import { WidgetBuilderVarService } from './widget-builder-var.service';
import { WidgetBuilderVarService } from '../widget-builder-service/widget-builder-var.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { cdkOverlayRef } from 'src/app/shared/custom-overlay/cdk-overlay-ref';
import { CdkOverlyayService } from 'src/app/shared/custom-overlay/cdk-overlyay.service';
import { ChartTypeSelectorComponent } from '../chart-type-selector/chart-type-selector.component';
import { TemplateDropdownComponent } from 'src/app/shared/custom-overlay/template-dropdown/template-dropdown.component';
import { ErrorMsgHandler } from 'src/app/shared/errormanagement/handleerror';
import { SharedService } from 'src/app/services/shared.service';
import { DashboardBuilderService } from '../dashboard-builder-service/dashboard-builder.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogBoxComponent } from 'src/app/shared/dialog-box/dialog-box.component';
import { TimeZoneService } from 'src/app/services/time-zone.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FormGroup, UntypedFormBuilder, UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DashboardBuilderVarService } from '../dashboard-builder-service/dashboard-builder-var.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Metropolis_ExtraLight, Metropolis_Light, Metropolis_LightItalic, Metropolis_Medium, Metropolis_Regular, Metropolis_SemiBold } from 'src/assets/fonts/font';

interface ChartDataItem {
  name: string;
  value: number;
}


@Component({
  selector: 'app-chart-widget',
  templateUrl: './chart-widget.component.html',
  styleUrls: ['./chart-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartWidgetComponent implements OnInit, AfterViewInit {
  previewSelectedColorObj: any = "";

  selectedColorIndex: number = 10;
  previewRef: any;
  moreoptiontitles = this.sharedService.metaData.dashboard.dashboard_landing.widgetmenu
  private _data: any = {};
  @Input() mode: string;
  @Input() widgetId: string;
  @Input() widgetInfo: any = {};
  @Input() preview_subtitle: string = "";
  @Input()
  set data(value: any) {
    //console.log("Value =--->",value)
    if (value !== this._data) {
      this._data = value
      if (this._data) {
        if (Object.keys(this._data).length) {
//console.log("input data changed ==", this._data)
          this.setWidgetData()
          this.isProgress = false
          setTimeout(() => {
            if (!this.handledashboardwidgetnodata.status && !this.errorhandledashboardwidget.status) {
              this.initChart()
            }
            //  this.applyStyleToChart(this.chartInstance,this._data.style,this._data?.type)
          }, 0);

        }
      }
    }
  }


  get data(): any {
    return this._data;
  }

  chart_type: string = "";
  title: string = "";
  subtitle: string = ""
  chartData: any = {};
  chartOptions: any = {};
  filterDays: any;


  handledashboardwidgetnodata = new ErrorMsgHandler()
  errorhandledashboardwidget = new ErrorMsgHandler()
  @ViewChild('chartContainer', { static: false }) chartContainer!: ElementRef;

  private chartInstance: any;

  constructor(private widgetBuilderVarService: WidgetBuilderVarService,
    private cdkOverlyayService: CdkOverlyayService,
    private sharedService: SharedService,
    private dashboardBuilderService: DashboardBuilderService,
    public dashboardBuilderVarService: DashboardBuilderVarService,
    public matDialog: MatDialog,
    private timeZoneService: TimeZoneService,
    private dashboardService: DashboardService,
    private fb: UntypedFormBuilder,
    private cdf: ChangeDetectorRef
  ) { }

  private destroy$: Subject<void> = new Subject<void>();



  overlayRef: cdkOverlayRef;
  dialogRef: any;
  isProgress: boolean = true;

  maxdate = this.timeZoneService.getcurrentuserTime().format('YYYY-MM-DD')
  mindate = this.timeZoneService.toUserTimeZone(this.sharedService.timeRange.event_time_range[0]).format('YYYY-MM-DD');

  defaultTimeRange = {
    from: this.timeZoneService.getcurrentuserTime().clone().startOf('D').format('YYYY-MM-DD'),
    to: this.timeZoneService.getcurrentuserTime().format('YYYY-MM-DD')
  }


  timeRange = this.fb.group({
    fromDate: new UntypedFormControl(this.defaultTimeRange.from),
    toDate: new UntypedFormControl(this.defaultTimeRange.to),
  }, { validators: [this.creatDateRangeValidator()] });

  selectTime = this.fb.group({
    fromDate: new UntypedFormControl(this.defaultTimeRange.from),
    toDate: new UntypedFormControl(this.defaultTimeRange.to),
  }, { validators: [this.creatDateRangeValidator()] });
  ngOnInit(): void {
    if (this.mode === "preview") {
//console.log("Preview")
      this.isProgress = false
    }
    this.resetdateinput()
    if (Object.keys(this._data).length) {
      this.setWidgetData()

    }

    if (this.mode === "builder") {

      this.filterDays = this.widgetInfo?.time_range[2]
      this.setTimeRange(this.widgetInfo?.time_range)
      this.customSubtitle(this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
    }

    //console.log("Mode =---->",this.mode)
    // this.setDefaultData();
    // this.widgetBuilderVarService.previewColorpalette$.pipe(takeUntil(this.destroy$))
    // .subscribe((colorobj)=>{
    //   console.log(colorobj,"=============")
    //   this.previewSelectedColorObj = colorobj
    // })
    this.widgetBuilderVarService.previewProgress$.pipe(takeUntil(this.destroy$))
      .subscribe((val) => {

        if (val) {
//console.log("Preview Progress", val)
          this.isProgress = true
        } else {
          this.isProgress = false
        }

      })
  }
  expand() {
    if (this.chartInstance) {
//console.log("Resize")
      this.chartInstance.resize()
    }
  }

  ngDoCheck() {
    this.cdf.detectChanges();
  }
  ngAfterViewInit(): void {

    // setTimeout(() => {
    //   this.widgetBuilderVarService.testImage='/assets/widgets/donut.svg'
    //   console.log("TEST IMAGE =---->",this.widgetBuilderVarService.testImage)
    //   this.cdf.detectChanges();
    // }, 2000);

    this.widgetBuilderVarService.previewColorpalette$.pipe(distinctUntilChanged(),takeUntil(this.destroy$)).subscribe((val:any) => {

//console.log("Color =---->", val)

//console.log("Chart type -> ",this._data.type)

//console.log("Mode -->" , this.mode)

//console.log(this.chartInstance)

      if (this.chartInstance) {

//console.log("Chart exists")
       
        
        if (this._data.type === 'polar_radial_bar' || this._data.type ===  'polar_tangential_bar') {
          

//console.log(this._data.type , "POLAR")

          const option = this.chartInstance.getOption();
        
          option.series[0].data = option.series[0].data.map((d: any, i: number) => {
        
            // if data is primitive number
            if (typeof d === 'number') {
              return {
                value: d,
                itemStyle: {
                  color: val[i % val.length]
                }
              };
            }
        
            // if already object
            return {
              ...d,
              itemStyle: {
                ...(d.itemStyle || {}),
                color: val[i % val.length]
              }
            };
        
          });
        
          this.chartInstance.setOption(option);
        }
        else if(this._data.type === 'heatmap' || this._data.type === 'polar_heatmap'){

          const option = this.chartInstance.getOption();
          option.visualMap = {
           
            inRange: {
              color : val
            }
          };
          this.chartInstance.setOption(option);
        }
        else if (this._data.type === 'treemap') {

          const option = this.chartInstance.getOption();
        
          const palette = val;
        
          option.series[0].data = option.series[0].data.map((node, i) => ({
            ...node,
            itemStyle: {
              ...(node.itemStyle || {}),
              color: palette[i % palette.length]
            }
          }));
        
          this.chartInstance.setOption(option);
        
        }
        else if(this._data.type == 'guard_guage'){

//console.log("Guard Guage")
        
          const colors = val;
        
          const option = this.chartInstance.getOption();
        
          option.series[0].axisLine.lineStyle.color = [
            [0.1, colors[0] || '#58D9F9'],
            [0.5, colors[1] || '#FDDD60'],
            [1, colors[2] || '#FF6E76']
          ];
        
          option.series[0].title.color =
            colors[3] || '#464646';
        
          option.series[0].axisLabel.color =
            colors[3] || '#464646';
        
          option.series[0].detail.color =
            colors[3] || '#464646';
        
          this.chartInstance.setOption(option);
        }
        else if(this._data.type == 'line_stack' || this._data.type == 'area_stack' || this._data.type == 'bar_stack'){
//console.log("AREA STACK")
  
            const option = this.chartInstance.getOption();
          
            option.color = val;

            // option.xAxis[0]["boundaryGap"]=false
          
            option.series.forEach((series: any, index: number) => {
          
              const color = val[index % val.length];
          
              series.color = color;
          
              series.lineStyle = {
                ...(series.lineStyle || {}),
                color
              };

              let areaStack = false
              if(this.mode == "preview"){
                areaStack =this._data.type == 'area_stack' && this.widgetBuilderVarService.chartType == 'area_stack'
              }else{
                areaStack =this._data.type == 'area_stack' || this.widgetBuilderVarService.chartType == 'area_stack'
              }
              if(areaStack){
//console.log("AREA")
                series.areaStyle =  {
                  color,
                  // opacity: 0.4
                
                }
                series.itemStyle = {
                  ...(series.itemStyle || {}),
                  color: '#fff',
                  borderColor: color,
                  borderWidth: 2
                };
            
                series.emphasis = {
                  ...(series.emphasis || {}),
                  itemStyle: {
                    ...(series.emphasis?.itemStyle || {}),
                    color: '#fff',
                    borderColor: color,
                    borderWidth: 2
                  }
                };
              }else if(this.widgetBuilderVarService.chartType == 'line_stack'){
                delete series.areaStyle;
              }
              else {
//console.log("NOT AREA")
                  delete series.areaStyle;
                  series.itemStyle={
                    color: color
                  }
              }
          
             
            });
          
            this.chartInstance.setOption(option,true);
          
        }
      else{
        this.chartInstance.setOption({
          color: val
        });
      
      }
      this.chartOptions = this.chartInstance.getOption();
    }
      

      

    })
   

    setTimeout(() => {
      this.initChart()
    }, 0);

    this.widgetBuilderVarService.getPanelState().pipe(takeUntil(this.destroy$)).subscribe(val => {
      // console.log("chart change")
      if (val.isExpanded) {
        setTimeout(() => {
          this.expand()
        }, 200);
      } else {
        setTimeout(() => {
          this.expand()
        }, 200);
      }

      // this.initChart()

    })

    this.widgetBuilderVarService.refreshChart$.pipe(takeUntil(this.destroy$)).subscribe(val => {
      //console.log("Reset =---->", val)
      if (val === "reset") {
        //console.log("reset")
        if (this.chartInstance) {
          this.chartInstance.dispose()
          this.chartData = {}
          setTimeout(() => {
            this.initChart()

            this.applyStyleToChart(this.chartInstance, this._data.style, this.widgetBuilderVarService.chartType)

          }, 0);
        }
      } else {
        if (this.chartInstance) {
          this.chartInstance.dispose()
          setTimeout(() => {
            this.initChart()

            this.applyStyleToChart(this.chartInstance, this._data.style, this.widgetBuilderVarService.chartType)
          }, 0);
        }
      }
    })
  }

  creatDateRangeValidator(): ValidatorFn {
    return (form: FormGroup): ValidationErrors | null => {
      const err = {}
      const start = this.timeZoneService.setcurrentuserTime(form.get("fromDate").value);
      const end = this.timeZoneService.setcurrentuserTime(form.get("toDate").value);

      if (start && end) {
        const validyear = start.year() > 2000 && end.year() > 2000;
        if (!validyear) {
          err['yearrange'] = true;
        }
        const isRangeValid = (end.unix() - start.unix() >= 0) && (end || start) < this.timeZoneService.getcurrentuserTime();

        if (!isRangeValid) {
          err['dateRange'] = true;
        }
      }
      return err;
    }
  }

  isObjectEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length === 0;
  }

  setDefaultData(): void {
    this.widgetBuilderVarService.chartData = [
      { name: 'Mon', value: 120 },
      { name: 'Tue', value: 200 },
      { name: 'Wed', value: 150 },
      { name: 'Thu', value: 280 },
      { name: 'Fri', value: 230 },
      { name: 'Sat', value: 180 },
    ];
  }

  setWidgetData() {
    this.errorhandledashboardwidget.resetError()
    this.handledashboardwidgetnodata.resetError()
    if (this.mode == "builder") {
//console.log("mode builder", this._data)
      if (this._data.hasOwnProperty("error")) {
        this.errorhandledashboardwidget.seterror(true, this._data.error?.errmsg);
      }
      else {
        if (this.preview_subtitle) {
          this.subtitle = this.preview_subtitle
        }
        this.chart_type = this._data["type"]
        this.title = this._data["title"]
//console.log(this.title, "=============title")
        if (!this._data["widgetdata"]?.rows?.length) {
          this.handledashboardwidgetnodata.seterror(true, this.sharedService.metaData.alert.noDatamsg[1])
        } else {
          this.chartData = this._data["widgetdata"]
          if(this.chart_type.includes("stack")){
            this.chartData = this.formatWidgetData(this.chartData,true)
          }else{
            this.chartData = this.formatWidgetData(this.chartData)
          }
          
        }
      }

      this.cdf.detectChanges()
    } else if (this.mode === "preview") {
      if (this._data.hasOwnProperty("error")) {
        this.errorhandledashboardwidget.seterror(true, this._data.error?.errmsg);
      }
      else {
        this.chart_type = this._data["type"]
        this.title = this._data["title"]
        this.subtitle = this._data["subtitle"]
//console.log(this.title, "=============title")
        if (!this._data["widgetdata"]?.rows?.length) {
          this.handledashboardwidgetnodata.seterror(true, this.sharedService.metaData.alert.noDatamsg[1])
        } else {
          this.chartData = this._data["widgetdata"]
          if(this.chart_type.includes("stack")){
            this.chartData = this.formatWidgetData(this.chartData,true)
          }else{
            this.chartData = this.formatWidgetData(this.chartData)
          }
        }
      }
    }
  }

  applyStyleToChart(chart: any, style: any, chartType) {

//console.log("Chart type ->", chartType)

    if (this.chartInstance) {

    //console.log("Style =---->", style)
    let dynamicNameGap = 25;
    let dynamicGridLeft = "6%";
      const option: any = {};

      if (!['pie', 'donut', 'guard_guage', 'sankey', 'polar_heatmap', 'polar_tangential_bar', 'polar_radial_bar', 'treemap', 'nightingale'].includes(chartType)) {

        // ---------------- AXES ----------------
        if (style.axes) {
          if (style.axes["x-axis"]) {
            const x = style.axes["x-axis"];

            if (x.enable) {

              option.xAxis = {
                // show: x.enable ? true : false,
                show: true,
                name: x.name ?? '',
                nameLocation: x.position ?? '',
                nameGap: 25,
                nameTextStyle: {
                  fontSize: x["font-size"] ?? 12,
                  fontWeight:'bold'
                },
                // axisLabel: {
                //   fontSize: x["font-size"] ?? 12
                // }
              };

            }
          }

          const yAxisData =
          this.chartInstance?.getOption()?.yAxis?.[0]?.data || this.chartInstance?.getOption()?.series?.[0]?.data || [];
        
        const longestLength = Math.min(
          Math.max(
            ...yAxisData.map((v: any) => String(v).length),
            0
          ),
          11
        );
        
        /*
          Dynamic spacing
        */
// console.log(this.chartInstance?.getOption())
// console.log({yAxisData})

// console.log({longestLength})
        
        dynamicNameGap = 25 + (longestLength * 4);
        
        /*
          Convert character length into %
        */
        
        const leftPercent = 3 + (longestLength * 0.7);
        
        dynamicGridLeft = `${Math.min(leftPercent, 10)}%`;

          if (style.axes["y-axis"]) {
            const y = style.axes["y-axis"];

//console.log({ y })

            if (y.enable) {
              option.yAxis = {
                // show: y.enable ? true : false,
                show: true,
                name: y.name ?? '',
                nameLocation: y.position ?? '',
                // nameGap: chartType == 'heatmap' || chartType == 'horizontal_bar' ? 75 : 65,
                nameGap: dynamicNameGap + 15,
                nameTextStyle: {
                  fontSize: y["font-size"] ?? 12,
                  fontWeight:'bold'
                },
                // axisLabel: {
                //   fontSize: y["font-size"] ?? 12
                // }
              };
            }
          }
        }
//console.log(option)

        // ---------------- COMPACT ----------------

        if ((this.chartOptions.xAxis || this.chartOptions.yAxis) && chartType != 'heatmap' ) {

          let axis = 'yAxis'

          if(chartType == 'horizontal_bar'){
            axis ='xAxis'
          }

          if(style.compact?.mode === 'auto' ){

            this._data?.widgetdata?.headers?.forEach(val=>{
              if(val.value === 'metric1'){
                if(val.type === 'size'){
                  option[axis] = {
                    ...option[axis],
                    axisLabel: {
                      ...option[axis]?.axisLabel,
                      formatter: (value: number) => {
                        return this.dashboardService.getFormaterSize()(value);
                      }
                    }
                  };
                }else{
                  option[axis] = {
                    ...option[axis],
                    axisLabel: {
                      ...option[axis]?.axisLabel,
                      formatter: (value: number) => {
                        return this.dashboardService.getFormaterFunction()(value);
                      }
                    }
                  };
                }
              }
            })

          }else{
            if (style.compact?.type === 'number') {
              option[axis] = {
                ...option[axis],
                axisLabel: {
                  ...option[axis]?.axisLabel,
                  formatter: (value: number) => {
                    return this.dashboardService.getFormaterFunction()(value);
                  }
                }
              };
            } else {
              option[axis] = {
                ...option[axis],
                axisLabel: {
                  ...option[axis]?.axisLabel,
                  formatter: (value: number) => {
                    return this.dashboardService.getFormaterSize()(value);
                  }
                }
              };
            }
          }

         
        }
      }
      //console.log(option)

      // ---------------- LEGEND ----------------
      //     if (style.legend) {

      // //console.log("Legend")
      //       const l = style.legend;

      //       option.legend = {
      //         show: l.enable ?true : false,
      //         icon: l.icon ?? 'circle',
      //         type: l.type ?? 'plain',
      //         itemWidth: 5,   
      //         itemHeight: 14,
      //       };

      //       // option["grid"]={
      //       //   top:"20%",
      //       //   left: "2%",
      //       //   right: "2%",
      //       //   bottom: "2%",
      //       //   containLabel:true
      //       // }
      //     }
      // else{
      // this.chartInstance.setOption({grid: {
      //   top: "4%",
      //   left: "2%",
      //   right: "2%",
      //   bottom: "2%",
      //   containLabel:true
      // }
      // })
      // }




    option.color = style.color_palette


    // ---------------COLOR----------------

    if (
      this._data.type === 'polar_radial_bar' ||
      this._data.type === 'polar_tangential_bar'
    ) {
    
      const palette = style.color_palette?.length
        ? style.color_palette
        : [
            "#a6d4e7",
            "#0081b8",
            "#737373",
            "#454545",
            "#e0eff6",
            "#9e57bc",
            "#5fb3d9",
            "#b8c4cc",
            "#6c2f8f"
          ];
    
      const option = this.chartInstance.getOption();
    
      if(option.series.length){
         option.series[0].data = option.series?.[0]?.data.map((d: any, i: number) => {
    
        const color = palette[i % palette.length];
    
        // primitive number
        if (typeof d === 'number') {
          return {
            value: d,
            itemStyle: {
              color
            }
          };
        }
    
        // existing object
        return {
          ...d,
          itemStyle: {
            ...(d.itemStyle || {}),
            color
          }
        };
    
      });
      }
     
    
      this.chartInstance.setOption(option);
    }
    
    else if(this._data.type === 'heatmap' || this._data.type === 'polar_heatmap'){
//console.log("Color =---->",this._data.style.color_palette )

      
      option.visualMap={
      inRange: {
        color :this._data.style.color_palette ? this._data.style.color_palette  : ["#f6efa6","#d88273","#bf444c"]
        
      }
    }
    }
    else if (this._data.type === 'treemap') {

      let val = this._data.style.color_palette? this._data.style.color_palette : this.chartInstance.getOption().color

      const option = this.chartInstance.getOption();
    
      const palette = val;
    
      option.series[0].data = option.series[0].data.map((node, i) => ({
        ...node,
        itemStyle: {
          ...(node.itemStyle || {}),
          color: palette[i % palette.length]
        }
      }));
    
      this.chartInstance.setOption(option);
    
    }


      //console.log(option)

      if (!['pie', 'donut', 'guard_guage', 'sankey', 'polar_heatmap', 'polar_tangential_bar', 'polar_radial_bar', 'treemap', 'nightingale'].includes(chartType)) {

        option["grid"] = {
          top: style?.legend?.enable ? "15%" : "4%",
          // left: style.axes?.["y-axis"]?.enable ? "6%" : '2%',
          left: style.axes?.["y-axis"]?.enable
          ? dynamicGridLeft
          : '2%',
          // right: style.axes?.["y-axis"]?.enable ? "6%" : '2%',
          right: style.axes?.["y-axis"]?.enable
          ? dynamicGridLeft
          : '2%',
          bottom: style.axes?.["x-axis"]?.enable ? "10%" : '2%',
          containLabel: true
        }

        // option["tooltip"] = { show: true, }
        if(chartType != 'heatmap' && chartType != 'polar_heatmap'){
          if( chartType === 'bar_stack' ||
          chartType === 'line_stack' ||
          chartType === 'area_stack'){
            this.stackedTooltip(style,option,chartType)
          }else{
            this.basicTooltip(style,option)
          }
        }
        

        if (this.widgetBuilderVarService.setupForm.get('setup').get('metrics').get('metrics_slider').value) {
          option["dataZoom"] = { show: true }
          option.grid.bottom = ((parseFloat(option.grid.bottom) || 0) + 33) + "%";
        }

        if (style.legend) {
          const l = style.legend;
        
          let valueFormatter 

              if(style.compact?.mode === 'auto' ){

                this._data?.widgetdata?.headers?.forEach(val=>{
                  if(val.value === 'metric1'){
                    if(val.type === 'size'){
                      valueFormatter = this.dashboardService.getFormaterSize();
                    }else{
                      valueFormatter = this.dashboardService.getFormaterFunction();
                    }
                  }
                })
          
              }else{
                if (style?.compact?.type === 'number') {
                  valueFormatter = this.dashboardService.getFormaterFunction();
                } else if (style?.compact?.type === 'size') {
                  valueFormatter = this.dashboardService.getFormaterSize();
                }
              }
        
          option.legend = {
            show: !!l.enable,
            icon: l.icon ?? 'circle',
            type: l.type ?? 'scroll',
            itemWidth: 5,
            itemHeight: 14,
            itemGap:7,
            orient: 'horizontal',
            left: 'center',
            top: 0,
            "textStyle": {
              "fontSize": 10
          },
          "pageIconSize": 10,
          pageIcons: {
            horizontal: [
              'path://M14.1 3.6L7.5 10l6.6 6.4c0.4 0.4 1 0.4 1.3 0c0.4-0.4 0.4-1 0-1.3L10.2 10l5.2-5.1c0.4-0.4 0.4-1 0-1.3c-0.3-0.4-0.9-0.4-1.3 0z',
          
              'path://M7.5 3.6L14.1 10l-6.6 6.4c-0.4 0.4-1 0.4-1.3 0c-0.4-0.4-0.4-1 0-1.3L11.4 10L6.2 4.9c-0.4-0.4-0.4-1 0-1.3c0.3-0.4 0.9-0.4 1.3 0z'
            ],
            vertical: [
              // Up
              'path://M2.8 13.4L10 6.2l7.2 7.2c0.5 0.5 1.2 0.5 1.6 0c0.5-0.5 0.5-1.2 0-1.6L10 2.9l-8.8 8.9c-0.5 0.5-0.5 1.2 0 1.6c0.4 0.5 1.1 0.5 1.6 0z',
            
              // Down
              'path://M2.8 6.6L10 13.8l7.2-7.2c0.5-0.5 1.2-0.5 1.6 0c0.5 0.5 0.5 1.2 0 1.6L10 17.1L1.2 8.2c-0.5-0.5-0.5-1.2 0-1.6c0.4-0.5 1.1-0.5 1.6 0z'
            ]
          },
        
            formatter: function (name) {
        
              const series = chart
                .getOption()
                .series.find((s: any) => String(s.name) === String(name));
        
              // total for stacked charts
              let value: any;
        
              if (series?.stack) {
        
                value = (series.data || []).reduce(
                  (sum: number, val: any) =>
                    sum + (typeof val === 'object' ? Number(val?.value || 0) : Number(val || 0)),
                  0
                );
        
              } else {
        
                // normal bar/line/area
                value = (series?.data || []).reduce(
                  (sum: number, val: any) =>
                    sum + (typeof val === 'object' ? Number(val?.value || 0) : Number(val || 0)),
                  0
                );
        
              }
        
              const formattedValue = valueFormatter
                ? valueFormatter(value)
                : value;
        
              return `${formattedValue} : ${name}`;
            }
          };
        }
      } else {
        option["grid"] = {
          top: style?.legend?.enable ? "20%" : "4%",
          left: '2%',
          right: "20%",
          bottom: '2%',
          // containLabel:true
        }

        

        if(style?.legend?.enable && chartType != 'guard_guage'){
          let legendOption=this.chartInstance.getOption()
          legendOption.series[0]["center"]=["30%","50%"]
          this.chartInstance.setOption(legendOption)
        }

        // option["tooltip"] = { show: true }
        // let valueFormatter = (v: any) => v;

        if(chartType != 'heatmap' && chartType != 'polar_heatmap' && chartType != 'sankey' && chartType != 'treemap'){
          this.basicTooltip(style,option)
        }

        delete option.xAxis
        delete option.yAxis

        if (style.legend) {

          const l = style.legend;

          let valueFormatter 
          if(style.compact?.mode === 'auto' ){

            this._data?.widgetdata?.headers?.forEach(val=>{
              if(val.value === 'metric1'){
                if(val.type === 'size'){
                  valueFormatter = this.dashboardService.getFormaterSize();
                }else{
                  valueFormatter = this.dashboardService.getFormaterFunction();
                }
              }
            })
      
          }else{
            if (style?.compact?.type === 'number') {
              valueFormatter = this.dashboardService.getFormaterFunction();
            } else if (style?.compact?.type === 'size') {
              valueFormatter = this.dashboardService.getFormaterSize();
            }
          }

          option.legend = {
            show: l.enable ? true : false,
            icon: l.icon ?? 'circle',
            type: l.type ?? 'scroll',
            itemWidth: 5,
            itemHeight: 14,
            itemGap:7,
            "textStyle": {
              "fontSize": 10
            },
            "orient": "vertical",
            "right": "5%",
            "top": "center",
            "pageIconSize": 10,
            pageIcons: {
              horizontal: [
                'path://M14.1 3.6L7.5 10l6.6 6.4c0.4 0.4 1 0.4 1.3 0c0.4-0.4 0.4-1 0-1.3L10.2 10l5.2-5.1c0.4-0.4 0.4-1 0-1.3c-0.3-0.4-0.9-0.4-1.3 0z',
            
                'path://M7.5 3.6L14.1 10l-6.6 6.4c-0.4 0.4-1 0.4-1.3 0c-0.4-0.4-0.4-1 0-1.3L11.4 10L6.2 4.9c-0.4-0.4-0.4-1 0-1.3c0.3-0.4 0.9-0.4 1.3 0z'
              ],
              vertical: [
                // Up
                'path://M2.8 13.4L10 6.2l7.2 7.2c0.5 0.5 1.2 0.5 1.6 0c0.5-0.5 0.5-1.2 0-1.6L10 2.9l-8.8 8.9c-0.5 0.5-0.5 1.2 0 1.6c0.4 0.5 1.1 0.5 1.6 0z',
              
                // Down
                'path://M2.8 6.6L10 13.8l7.2-7.2c0.5-0.5 1.2-0.5 1.6 0c0.5 0.5 0.5 1.2 0 1.6L10 17.1L1.2 8.2c-0.5-0.5-0.5-1.2 0-1.6c0.4-0.5 1.1-0.5 1.6 0z'
              ]
            },
          
            tooltip: {
              show: true,
              formatter: function (params: any) {
                return params.name;
              }
            },
          
            formatter: function (name) {
              const item = chart.getOption().series[0].data.find(
                (d: any) => String(d.name) === String(name)
              );
          
              const formattedValue = valueFormatter
                ? valueFormatter(item?.value)
                : item?.value;
          
              const truncatedName =
                String(name).length > 12
                  ? `${String(name).slice(0, 12)}...`
                  : name;
          
              return `${formattedValue} : ${truncatedName}`;
            }
          };
        }

      }

//console.log({ option })


      if ( // remove visual map
        chartType !== 'polar_heatmap' && chartType !== 'heatmap'
      ) {
//console.log("Remove visual map")
        // option.visualMap = {
        //   show:false,
        //   min:0,
        //   max:0,
        //   inRange: {
        //     color: style.color_palette
        // }
        // }
        option.visualMap=[]
        // delete option.visualMap
      }

// console.log(option)



      // ---------------- APPLY ----------------
      this.chartInstance.setOption(option);

      // this.chartInstance.setOption({dataZoom:[{show:true}]})
      this.chartOptions = chart.getOption()

      // if ( // remove visual map
      //   chartType !== 'polar_heatmap' && chartType !== 'heatmap'
      // ) {
      //   delete this.chartOptions.visualMap

      //   this.chartInstance.setOption(this.chartOptions,true)
      // }

      // if((!Object.keys(option).includes('xAxis') || !Object.keys(option).includes('yAxis')) && Object.keys(this.chartData).includes('rows') && ['pie', 'donut' , 'guard_guage' , 'sankey','polar_heatmap','polar_tangential_bar','polar_radial_bar','treemap','nightingale'].includes(chartType) ){
      //   console.log("Delete Axes")
      //   if(Object.keys(this.chartOptions).includes('xAxis')){
      //     this.chartOptions.xAxis =[]
      //   }
      //   if(Object.keys(this.chartOptions).includes('yAxis')){
      //     this.chartOptions.yAxis =[]
      //   }
      //   this.chartInstance.setOption(this.chartOptions,true);
      // }



      // if (
      //   ['pie', 'donut', 'guard_guage', 'sankey',
      //    'polar_heatmap', 'polar_tangential_bar',
      //    'polar_radial_bar', 'treemap', 'nightingale']
      //     .includes(chartType)
      // ) {

      //   this.chartInstance.setOption(
      //     {
      //       xAxis: [],
      //       yAxis: [],
      //       // grid: []
      //     },
      //     {
      //       replaceMerge: ['xAxis', 'yAxis', 'grid']
      //     }
      //   );

      // }

      // this.chartOptions = chart.getOption()

//console.log(this.chartOptions.series.map((s: any) => s.color));

// console.log(this.chartOptions)



      //console.log(option)
    }
  }

  basicTooltip(style,option){
    let valueFormatter = (v: any) => v;

    if(style.compact?.mode === 'auto' ){

      this._data?.widgetdata?.headers?.forEach(val=>{
        if(val.value === 'metric1'){
          if(val.type === 'size'){
            valueFormatter = this.dashboardService.getFormaterSize();
          }else{
            valueFormatter = this.dashboardService.getFormaterFunction();
          }
        }
      })

    }else{
      if (style?.compact?.type === 'number') {
        valueFormatter = this.dashboardService.getFormaterFunction();
      } else if (style?.compact?.type === 'size') {
        valueFormatter = this.dashboardService.getFormaterSize();
      }
    }

    

    option.tooltip = {
      trigger: 'item',

      formatter: (params: any) => {
        const formattedValue = valueFormatter(params?.value);

        return `
          <div>
            ${params?.name} : <strong>${formattedValue}</strong>
          </div>
        `;
      }
    };
  }

  stackedTooltip(style, option, chartType?) {

    let valueFormatter = (v: any) => v;
  
    if(style.compact?.mode === 'auto' ){

      this._data?.widgetdata?.headers?.forEach(val=>{
        if(val.value === 'metric1'){
          if(val.type === 'size'){
            valueFormatter = this.dashboardService.getFormaterSize();
          }else{
            valueFormatter = this.dashboardService.getFormaterFunction();
          }
        }
      })

    }else{
      if (style?.compact?.type === 'number') {
        valueFormatter = this.dashboardService.getFormaterFunction();
      } else if (style?.compact?.type === 'size') {
        valueFormatter = this.dashboardService.getFormaterSize();
      }
    }
  
    option.tooltip = {
  
      trigger: 'item',
  
      triggerOn: 'mousemove',
  
      axisPointer: {
  
        type:
          chartType === 'bar_stack'
            ? 'shadow'
            : 'line',
  
        snap: true,
  
        triggerTooltip: true
      },
  
      formatter: (params: any) => {
  
        if (!params?.length) {
          return '';
        }
  
        const axisLabel =
          params?.[0]?.axisValueLabel ||
          params?.[0]?.axisValue ||
          '';
  
        // Remove duplicates
        const uniqueParams = Array.from(
  
          new Map(
  
            params.map((p: any) => [
              p.seriesName,
              p
            ])
  
          ).values()
  
        );
  
        const items = uniqueParams.map((p: any) => {
  
          const rawValue =
            Array.isArray(p.value)
              ? p.value[p.encode?.y?.[0] ?? 1]
              : p.value;
  
          const formattedValue =
            valueFormatter(rawValue ?? 0);
  
          return `
            <div style="
              display:flex;
              align-items:center;
              justify-content:space-between;
              gap:12px;
              margin-top:6px;
            ">
  
              <div style="
                display:flex;
                align-items:center;
                gap:6px;
              ">
  
                <span style="
                  display:inline-block;
                  width:10px;
                  height:10px;
                  border-radius:50%;
                  background:${p.borderColor};
                "></span>
  
                <span>
                  ${p.seriesName}
                </span>
  
              </div>
  
              <strong>
                ${formattedValue}
              </strong>
  
            </div>
          `;
  
        }).join('');
  
        return `
          <div style="min-width:140px;">
  
            <div style="
              font-weight:600;
              margin-bottom:8px;
            ">
              ${axisLabel}
            </div>
  
            ${items}
  
          </div>
        `;
      }
    };
  }

  initChart(): void {
    if (!this.chartContainer) return;

    // Dispose old instance before creating new
    if (this.chartInstance && !this.chartInstance.isDisposed()) {
      this.chartInstance.dispose();
    }

    this.chartInstance = echarts.init(
      this.chartContainer.nativeElement,
      null,
      { renderer: 'canvas' }
    );

    // const chartType = this.widgetBuilderVarService.chartType;
    const chartType = this.chart_type;
    const configMap = this.widgetBuilderVarService.chartOptions;

    let option: any;

    //console.log('Type of chart =---->', chartType);

    const getValue = (val: any) =>
      Number(String(val).replace(/,/g, '')) || 0;

    // ─── Helper: parse new mockTableData structure ───────────────────────
    const parseTableData = () => {

      // const { rows } = this.widgetBuilderVarService.rawData;
      const { rows } = this.chartData;
    
      if (!rows?.length) {
    
        return {
          xAxisData: [],
          series: [],
          dimensionKeys: [],
          metricKeys: [],
          rows: []
        };
      }
    
      // Derive dimension/metric keys from the first row's keys
      const allKeys = Object.keys(rows[0]);
    
      const dimensionKeys = allKeys.filter(
        (k) => k.startsWith('dimension')
      );
    
      const metricKeys = allKeys.filter(
        (k) => k.startsWith('metric')
      );
    
      let xAxisData: any[] = [];
    
      // keep original values for heatmaps
      if (
        chartType === 'heatmap' ||
        chartType === 'polar_heatmap'
      )
       {
    
        xAxisData = rows.map(
          (row: any) =>
            row[dimensionKeys[0]] ?? ''
        );
    
      } else {

//console.log("TIME DIMENSION")
    
        // detect time dimension
        const timeDimensionKey =
          this._data?.widgetdata?.headers?.find(
            (h: any) =>
              h.type?.toLowerCase() === 'timestamp' 
          )?.value;
    
        xAxisData = rows.map(
          (row: any) => {
    
            const value =
              row[dimensionKeys[0]] ?? '';
    
            const isHourlyFormat =
              /^(0\d|1\d|2[0-3])$/.test(
                String(value)
              );
    
            if (
              dimensionKeys[0] ===
                timeDimensionKey &&
              isHourlyFormat
            ) {
    
              const h = parseInt(
                String(value),
                10
              );
    
              const suffix =
                h >= 12
                  ? 'pm'
                  : 'am';
    
              const hour12 =
                h % 12 || 12;
    
              return `${hour12}${suffix}`;
            }
    
            return value;
          }
        );
      }
    
      // Build one series per metric key
      const series = metricKeys.map(
        (key: string) => ({
    
          name: key,
    
          data: rows.map(
            (row: any) =>
              getValue(row[key])
          ),
        })
      );
    
      return {
        xAxisData,
        series,
        dimensionKeys,
        metricKeys,
        rows
      };
    };
    // ─────────────────────────────────────────────────────────────────────

    if (chartType) {
      option = JSON.parse(JSON.stringify(configMap[chartType]));

      const { xAxisData, series: seriesData, rows, dimensionKeys, metricKeys } =
        parseTableData();

      // ── PIE / DONUT ──────────────────────────────────────────────────────
      if (chartType === 'pie' || chartType === 'donut') {
        option.series[0].data = xAxisData.map((name: string, i: number) => ({
          name,
          value: getValue(seriesData[0]?.data[i]),
        }));
        option.series[0].label = false
      }

      // ── HEATMAP ──────────────────────────────────────────────────────────
     else if (chartType === 'heatmap') {

    const xAxisKey = dimensionKeys[0];
    const yAxisKey = dimensionKeys[1];
    const metricKey = metricKeys[0];

    const LABEL_LIMIT = 10;

    // detect which dimension is Time dynamically
    const timeHeader =
      this._data?.widgetdata?.headers?.find(
        (h: any) =>
          h.type?.toLowerCase() === 'timestamp' 
      );

    const timeDimensionKey =
      timeHeader?.value;

    const isXAxisTime =
      timeDimensionKey === xAxisKey;

    // detect whether values are hourly format
    // supports:
    // 00,01,02...23
    // 12AM,1PM,2am,11 pm
    const rawTimeValues = rows.map(
      (r: any) => r[xAxisKey]
    );

    const isHourlyFormat =
      isXAxisTime &&
      rawTimeValues.every((v: any) => {

        if (
          v === null ||
          v === undefined
        ) {
          return false;
        }

        const str = String(v)
          .trim()
          .toUpperCase();

        const is24Hour =
          /^(0\d|1\d|2[0-3])$/.test(str);

        const is12Hour =
          /^(0?[1-9]|1[0-2])\s?(AM|PM)$/.test(str);

        return (
          is24Hour ||
          is12Hour
        );
      });

    const has12HourValues =
      rawTimeValues.some((v: any) =>
        /AM|PM/i.test(String(v))
      );

    // helper to convert 24h -> 12h AM/PM
    const formatHour12 = (
      hour: string
    ) => {

      const normalized =
        hour.trim().toUpperCase();

      // already in 12h format
      if (
        /^(0?[1-9]|1[0-2])\s?(AM|PM)$/.test(
          normalized
        )
      ) {
        return normalized.replace(
          /\s+/g,
          ''
        );
      }

      const h = parseInt(
        normalized,
        10
      );

      const suffix =
        h >= 12 ? 'PM' : 'AM';

      const hour12 =
        h % 12 || 12;

      return `${hour12}${suffix}`;
    };

    // helper to truncate labels
    const truncateLabel = (
      value: any
    ) => {

      const str = String(value);

      return str.length > LABEL_LIMIT
        ? str.slice(0, LABEL_LIMIT) + '...'
        : str;
    };

    // X Axis
    let xAxisData: any[] = [];

    if (
      isXAxisTime &&
      isHourlyFormat
    ) {

      // Fill all 24 hours
      xAxisData = has12HourValues
        ? [
            '12AM',
            '1AM',
            '2AM',
            '3AM',
            '4AM',
            '5AM',
            '6AM',
            '7AM',
            '8AM',
            '9AM',
            '10AM',
            '11AM',
            '12PM',
            '1PM',
            '2PM',
            '3PM',
            '4PM',
            '5PM',
            '6PM',
            '7PM',
            '8PM',
            '9PM',
            '10PM',
            '11PM'
          ]
        : Array.from(
            { length: 24 },
            (_, i) =>
              i
                .toString()
                .padStart(2, '0')
          );

    } else {

      xAxisData = [
        ...new Set(
          rows.map(
            (r: any) =>
              r[xAxisKey] ??
              'Unknown'
          )
        )
      ];
    }

    // Y Axis
    const yAxisData = [
      ...new Set(
        rows.map(
          (r: any) =>
            r[yAxisKey] ??
            'Unknown'
        )
      )
    ];

    option.grid = {
      top: '10%',
      bottom: '7%',
      right: '3%',
      left: '2%',
      containLabel: true
    };

    option.xAxis = {
      ...option.xAxis,

      type: 'category',

      data: xAxisData,

      axisLabel: {
        hideOverlap: true,

        formatter: (value: any) => {

          let formattedValue = value;

          if (
            isXAxisTime &&
            isHourlyFormat
          ) {
            formattedValue = formatHour12(
              String(value)
            );
          }

          return truncateLabel(
            formattedValue
          );
        }
      },

      splitArea: {
        show: true
      },

      axisPointer: {
        show: true,
        type: 'shadow'
      }
    };

    option.yAxis = {
      ...option.yAxis,

      type: 'category',

      data: yAxisData,

      axisLabel: {
        hideOverlap: true,

        formatter: (value: any) => {
          return truncateLabel(value);
        }
      },

      splitArea: {
        show: true
      },

      axisPointer: {
        show: true
      }
    };

    option.axisPointer = {
      show: true,

      type: 'shadow',

      shadowStyle: {
        color: 'none'
      },

      link: [
        {
          xAxisIndex: 'all',
          yAxisIndex: 'all'
        }
      ],

      label: {
        show: true,

        formatter: (params: any) => {

          const value = params.value;

          // X Axis pointer
          if (
            params.axisDimension === 'x' &&
            isXAxisTime &&
            isHourlyFormat
          ) {
            return formatHour12(
              String(value)
            );
          }

          // Y Axis pointer
          if (
            params.axisDimension === 'y'
          ) {
            return String(value);
          }

          return String(value);
        }
      }
    };

    // Build lookup map
    const valueMap = new Map();

    rows.forEach((row: any) => {

      let x =
        row[xAxisKey] ??
        'Unknown';

      // normalize hourly values
      if (
        isXAxisTime &&
        isHourlyFormat
      ) {
        x = formatHour12(
          String(x)
        );
      }

      const y =
        row[yAxisKey] ??
        'Unknown';

      const value =
        getValue(
          row[metricKey]
        );

      valueMap.set(
        `${x}__${y}`,
        value
      );
    });

    // Generate full matrix
    const heatmapData: any[] = [];

    yAxisData.forEach(
      (
        y: any,
        yIndex: number
      ) => {

        xAxisData.forEach(
          (
            x: any,
            xIndex: number
          ) => {

            const key =
              `${x}__${y}`;

            const value =
              valueMap.has(key)
                ? valueMap.get(
                    key
                  )
                : null;

            heatmapData.push([
              xIndex,
              yIndex,
              value
            ]);
          }
        );
      }
    );

    const allValues =
      heatmapData
        .map((d: any) => d[2])
        .filter(
          (v: any) =>
            v !== null &&
            v !== undefined
        );

    option.visualMap = {

      min: Math.min(
        ...allValues
      ),

      max: Math.max(
        ...allValues
      ),

      calculable: true,

      orient: 'horizontal',

      left: 'center',

      bottom: '15%',

      show: false,

      outOfRange: {
        color: ['transparent']
      }
    };

    let valueFormatter;

    if (
      this._data?.style.compact?.mode === 'auto'
    ) {

      this._data?.widgetdata?.headers?.forEach(
        val => {

          if (
            val.value === 'metric1'
          ) {

            if (
              val.type === 'size'
            ) {
              valueFormatter =
                this.dashboardService.getFormaterSize();
            } else {
              valueFormatter =
                this.dashboardService.getFormaterFunction();
            }
          }
        }
      );

    } else {

      if (
        this._data?.style?.compact?.type === 'number'
      ) {
        valueFormatter =
          this.dashboardService.getFormaterFunction();

      } else if (
        this._data?.style?.compact?.type === 'size'
      ) {
        valueFormatter =
          this.dashboardService.getFormaterSize();
      }
    }

    option.tooltip = {

      trigger: 'item',

      formatter: (p: any) => {

        if (
          !p ||
          !p.value ||
          !Array.isArray(
            p.value
          ) ||
          p.value[2] === null ||
          p.value[2] === undefined
        ) {
          return '';
        }

        const value =
          p.value;

        const rawX =
          xAxisData[
            value[0]
          ] ?? '';

        const x =
          isXAxisTime &&
          isHourlyFormat
            ? formatHour12(
                String(rawX)
              )
            : rawX;

        const rawY =
          yAxisData[
            value[1]
          ] ?? '';

        const metric =
          valueFormatter
            ? valueFormatter(
                value[2]
              )
            : value[2];

        return `
          <div style="
            display:flex;
            flex-direction:column;
            gap:6px;
            white-space:nowrap;
          ">

            <div>
              <strong>${rawY}</strong>
            </div>

            <div style="
              display:inline-flex;
              align-items:center;
              gap:6px;
            ">

              <span>
                ${x} :
              </span>

              <strong>
                ${metric}
              </strong>

            </div>

          </div>
        `;
      }
    };

    option.series = [{

      ...option.series[0],

      type: 'heatmap',

      data: heatmapData,

      label: {
        show: false
      },

      itemStyle: {
        borderColor: '#fff',
        borderWidth: 0
      },

      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowColor:
            'rgba(0, 0, 0, 0.5)'
        }
      }
    }];
  }
      // ── POLAR HEATMAP ────────────────────────────────────────────────────
      else if (chartType === 'polar_heatmap') {

        const angleKey =
          dimensionKeys[0];
      
        const radiusKey =
          dimensionKeys[1];
      
        const metricKey =
          metricKeys[0];
      
        // detect which dimension is Time dynamically
        const timeHeader =
          this._data?.widgetdata?.headers?.find(
            (h: any) =>
              h.type?.toLowerCase() ===
              'timestamp' 
          );
      
        const timeDimensionKey =
          timeHeader?.value;
      
        const isAngleTime =
          timeDimensionKey ===
          angleKey;
      
        // detect whether values are hourly format
        const rawTimeValues =
          rows.map(
            (r: any) =>
              r[angleKey]
          );
      
        const isHourlyFormat =
          isAngleTime &&
          rawTimeValues.every(
            (v: any) => {
      
              if (
                v === null ||
                v === undefined
              ) {
                return false;
              }
      
              const str =
                String(v)
                  .trim()
                  .toUpperCase();
      
              const is24Hour =
                /^(0\d|1\d|2[0-3])$/.test(
                  str
                );
      
              const is12Hour =
                /^(0?[1-9]|1[0-2])\s?(AM|PM)$/.test(
                  str
                );
      
              return (
                is24Hour ||
                is12Hour
              );
            }
          );
      
        const has12HourValues =
          rawTimeValues.some(
            (v: any) =>
              /AM|PM/i.test(
                String(v)
              )
          );
      
        // helper to convert 24h -> 12h AM/PM
        const formatHour12 = (
          hour: string
        ) => {
      
          const normalized =
            hour
              .trim()
              .toUpperCase();
      
          // already 12h format
          if (
            /^(0?[1-9]|1[0-2])\s?(AM|PM)$/.test(
              normalized
            )
          ) {
            return normalized.replace(
              /\s+/g,
              ''
            );
          }
      
          const h = parseInt(
            normalized,
            10
          );
      
          const suffix =
            h >= 12
              ? 'PM'
              : 'AM';
      
          const hour12 =
            h % 12 || 12;
      
          return `${hour12}${suffix}`;
        };
      
        // smaller global font
        option.textStyle = {
          fontSize: 10
        };
      
        // Angle categories
        let angleAxisData: any[] =
          [];
      
        if (
          isAngleTime &&
          isHourlyFormat
        ) {
      
          angleAxisData =
            has12HourValues
              ? [
                  '12AM',
                  '1AM',
                  '2AM',
                  '3AM',
                  '4AM',
                  '5AM',
                  '6AM',
                  '7AM',
                  '8AM',
                  '9AM',
                  '10AM',
                  '11AM',
                  '12PM',
                  '1PM',
                  '2PM',
                  '3PM',
                  '4PM',
                  '5PM',
                  '6PM',
                  '7PM',
                  '8PM',
                  '9PM',
                  '10PM',
                  '11PM'
                ]
              : Array.from(
                  { length: 24 },
                  (_, i) =>
                    i
                      .toString()
                      .padStart(
                        2,
                        '0'
                      )
                );
      
        } else {
      
          angleAxisData = [
            ...new Set(
              rows.map(
                (r: any) =>
                  r[
                    angleKey
                  ] ??
                  'Unknown'
              )
            )
          ];
        }
      
        // Radius categories
        const radiusAxisData = [
          ...new Set(
            rows.map(
              (r: any) =>
                r[
                  radiusKey
                ] ?? 'Unknown'
            )
          )
        ];
      
        option.polar = {
      
          center: ['48%', '50%'],
      
          radius: '80%'
        };
      
        option.angleAxis = {
          type: 'category',
      
          data: angleAxisData,
      
          boundaryGap: false,
      
          axisLabel: {
      
            fontSize: 10,
      
            // stronger text visibility
            color: '#444',
      
            formatter: (
              value: any
            ) => {
      
              if (
                isAngleTime &&
                isHourlyFormat
              ) {
                return formatHour12(
                  String(value)
                );
              }
      
              return value;
            }
          },
      
          // keep only tiny outer ticks
          axisTick: {
      
            show: true,
      
            alignWithLabel: true,
      
            inside: false,
      
            length: 6,
      
            lineStyle: {
              color: '#888',
              width: 1
            }
          },
      
          splitLine: {
            show: false
          },
      
          // remove outer circle completely
          axisLine: {
            show: false
          }
        };
      
        option.radiusAxis = {
          type: 'category',
      
          inverse: true,
      
          data: radiusAxisData,
      
          z: 100,
      
          axisLabel: {
      
            margin: 6,
      
            align: 'left',
      
            verticalAlign: 'middle',
      
            color: '#666',
      
            // smaller IP labels
            fontSize: 10
          },
      
          axisLine: {
            lineStyle: {
              opacity: 0.2
            }
          },
      
          splitLine: {
            show: false
          },
      
          axisTick: {
            show: false
          }
        };
      
        // Build lookup map
        const valueMap =
          new Map();
      
        rows.forEach(
          (row: any) => {
      
            let angle =
              row[
                angleKey
              ] ?? 'Unknown';
      
            if (
              isAngleTime &&
              isHourlyFormat
            ) {
              angle =
                formatHour12(
                  String(angle)
                );
            }
      
            const radius =
              row[
                radiusKey
              ] ?? 'Unknown';
      
            const value =
              getValue(
                row[
                  metricKey
                ]
              );
      
            valueMap.set(
              `${angle}__${radius}`,
              value
            );
          }
        );
      
        // Generate full matrix
        const heatmapData: any[] =
          [];
      
        radiusAxisData.forEach(
          (
            radius: any,
            radiusIndex: number
          ) => {
      
            angleAxisData.forEach(
              (
                angle: any,
                angleIndex: number
              ) => {
      
                const key =
                  `${angle}__${radius}`;
      
                const value =
                  valueMap.has(
                    key
                  )
                    ? valueMap.get(
                        key
                      )
                    : null;
      
                heatmapData.push([
                  angleIndex,
                  radiusIndex,
                  value
                ]);
              }
            );
          }
        );
      
        const allValues =
          heatmapData
            .map((d: any) => d[2])
            .filter(
              (v: any) =>
                v !== null &&
                v !== undefined &&
                !isNaN(v)
            );
      
        const minValue =
          allValues.length
            ? Math.min(...allValues)
            : 0;
      
        const maxValue =
          allValues.length
            ? Math.max(...allValues)
            : 1;
      
        option.visualMap = {
          type: 'continuous',
      
          min: minValue,
      
          max: maxValue,
      
          dimension: 2,
      
          calculable: true,
      
          top: 'middle',
      
          itemWidth: 8,
      
          itemHeight: 100,
      
          textStyle: {
      
            // smaller visualMap text
            fontSize: 9
          },
      
          inRange: {
            color: [
              '#05445E',
              '#189AB4',
              '#75E6DA'
            ]
          },
      
          outOfRange: {
            color: ['transparent']
          }
        };
      
        let valueFormatter
      
        if(this._data?.style.compact?.mode === 'auto' ){
      
          this._data?.widgetdata?.headers?.forEach(val=>{
            if(val.value === 'metric1'){
              if(val.type === 'size'){
                valueFormatter = this.dashboardService.getFormaterSize();
              }else{
                valueFormatter = this.dashboardService.getFormaterFunction();
              }
            }
          })
      
        }else{
          if (this._data?.style?.compact?.type === 'number') {
            valueFormatter = this.dashboardService.getFormaterFunction();
          } else if (this._data?.style?.compact?.type === 'size') {
            valueFormatter = this.dashboardService.getFormaterSize();
          }
        }
      
        // tooltip unchanged
        option.tooltip = {
          trigger: 'item',
      
          formatter: (
            p: any
          ) => {
      
            if (
              !p?.value ||
              p.value[2] ===
                null ||
              p.value[2] ===
                undefined
            ) {
              return '';
            }
      
            const value =
              p.value;
      
            const rawAngle =
              angleAxisData[
                value[0]
              ];
      
            const angle =
              isAngleTime &&
              isHourlyFormat
                ? formatHour12(
                    String(
                      rawAngle
                    )
                  )
                : rawAngle;
      
            const radius =
              radiusAxisData[
                value[1]
              ];
      
            const metric =
              valueFormatter
                ? valueFormatter(
                    value[2]
                  )
                : value[2];
      
            const angleLabel =
              this._data?.widgetdata?.headers?.find(
                (h: any) =>
                  h.value ===
                  timeDimensionKey
              )?.disp ||
              'Dimension 1';
      
            const metricLabel =
              this._data?.widgetdata?.headers?.find(
                (h: any) =>
                  h.value ===
                  'metric1'
              )?.disp ||
              'Metric';
      
            return `
              <div>
      
                <div>
                  ${radius}
                </div>
      
                <div style="
                  display:flex;
                  align-items:center;
                  justify-content:space-between;
                  gap:16px;
                ">
      
                  <span>
                    ${angleLabel}:
                  </span>
      
                  <span>
                    ${angle}
                  </span>
      
                </div>
      
                <div style="
                  display:flex;
                  align-items:center;
                  justify-content:space-between;
                  gap:6px;
                ">
      
                  <span>
                    ${metricLabel} :
                  </span>
      
                  <strong>
                    ${metric}
                  </strong>
      
                </div>
      
              </div>
            `;
          }
        };
      
        option.series = [{
          name: '',
      
          type: 'custom',
      
          coordinateSystem:
            'polar',
      
          data: heatmapData,
      
          renderItem: (
            params: any,
            api: any
          ) => {
      
            const currentValue =
              api.value(2);
      
            if (
              currentValue ===
                null ||
              currentValue ===
                undefined
            ) {
              return;
            }
      
            const angleIndex =
              api.value(0);
      
            const radiusIndex =
              api.value(1);
      
            const cx =
              params.coordSys.cx;
      
            const cy =
              params.coordSys.cy;
      
            const angleBand =
              (Math.PI * 2) /
              angleAxisData.length;
      
            const startAngle =
              angleIndex *
              angleBand;
      
            const endAngle =
              startAngle +
              angleBand;
      
            const bandWidth =
              params.coordSys.r /
              radiusAxisData.length;
      
            const r0 =
              radiusIndex *
              bandWidth;
      
            const r =
              r0 + bandWidth;
      
            return {
              type: 'sector',
      
              shape: {
                cx,
                cy,
      
                r0,
                r,
      
                startAngle:
                  startAngle -
                  Math.PI / 2,
      
                endAngle:
                  endAngle -
                  Math.PI / 2
              },
      
              style: {
      
                fill: api.visual(
                  'color'
                ),
      
                stroke:
                  'transparent',
      
                lineWidth: 0
              }
            };
          },
      
          encode: {
            value: 2
          }
        }];
      }

      // ── POLAR RADIAL BAR ─────────────────────────────────────────────
      else if (chartType === 'polar_radial_bar') {

        let valueFormatter

            if(this._data?.style.compact?.mode === 'auto' ){

              this._data?.widgetdata?.headers?.forEach(val=>{
                if(val.value === 'metric1'){
                  if(val.type === 'size'){
                    valueFormatter = this.dashboardService.getFormaterSize();
                  }else{
                    valueFormatter = this.dashboardService.getFormaterFunction();
                  }
                }
              })
        
            }else{
              if (this._data?.style?.compact?.type === 'number') {
                valueFormatter = this.dashboardService.getFormaterFunction();
              } else if (this._data?.style?.compact?.type === 'size') {
                valueFormatter = this.dashboardService.getFormaterSize();
              }
            }
      
        const polarData =
          seriesData?.[0]?.data?.map((d: any) => {
            return typeof d === 'object'
              ? d.value
              : d;
          }) || [];
      
        option.backgroundColor = '#ffffff';
      
        option.polar = {
          radius: ['22%', '82%']
        };
      
        option.angleAxis = {
      
          type: 'category',
      
          data: xAxisData,
      
          startAngle: 90,
      
          clockwise: true,
      
          axisLine: {
            show: false
          },
      
          splitLine: {
            show: false
          },
      
          axisTick: {
            show: true,
      
            inside: false,
      
            length: 4,
      
            lineStyle: {
              color: '#555',
              width: 1.5
            }
          },
      
          axisLabel: {
      
            interval: 0,
      
            fontSize: 11,
      
            color: '#555',
      
            margin: 22,
      
            overflow: 'truncate',
      
            width: 90
          }
        };
      
        option.radiusAxis = {
      
          min: 0,
      
          splitNumber: 6,
      
          axisLine: {
            show: false
          },
      
          axisTick: {
            show: false
          },
      
          axisLabel: {
      
            fontSize: 10,
      
            color: '#555',
      
            formatter: (value: any) => {
      
              return valueFormatter
                ? valueFormatter(value)
                : value;
            }
          },
      
          splitLine: {
      
            show: true,
      
            lineStyle: {
              color: '#cfd6df',
              width: 1.5
            }
          }
        };
      
        // option.tooltip = {
      
        //   trigger: 'item',
      
        //   backgroundColor: '#fff',
      
        //   borderColor: '#ddd',
      
        //   textStyle: {
        //     color: '#333',
        //     fontSize: 11
        //   },
      
        //   formatter: (params: any) => {
      
        //     const value = valueFormatter
        //       ? valueFormatter(params.value)
        //       : params.value;
      
        //     return `
        //       ${params.name}<br/>
        //       ${value}
        //     `;
        //   }
        // };
      
        option.legend = {
          show: false
        };
      
        option.textStyle = {
          fontFamily: 'sans-serif'
        };
      
        option.series = [
          {
      
            type: 'bar',
      
            coordinateSystem: 'polar',
      
            roundCap: false,
      
            barWidth: '85%',
      
            data: polarData,
      
            itemStyle: {
      
              color: '#0b8ecf',
      
              borderRadius: 0
            },
      
            emphasis: {
              focus: 'self'
            }
          }
        ];
      }

      // ── POLAR TANGENTIAL BAR ─────────────────────────────────────────────────
      else if (chartType === 'polar_tangential_bar') {

        let valueFormatter

            if(this._data?.style.compact?.mode === 'auto' ){

              this._data?.widgetdata?.headers?.forEach(val=>{
                if(val.value === 'metric1'){
                  if(val.type === 'size'){
                    valueFormatter = this.dashboardService.getFormaterSize();
                  }else{
                    valueFormatter = this.dashboardService.getFormaterFunction();
                  }
                }
              })
        
            }else{
              if (this._data?.style?.compact?.type === 'number') {
                valueFormatter = this.dashboardService.getFormaterFunction();
              } else if (this._data?.style?.compact?.type === 'size') {
                valueFormatter = this.dashboardService.getFormaterSize();
              }
            }
      
        option.polar = {
          ...option.polar,
          radius: '72%'
        };
      
        option.radiusAxis = {
          ...option.radiusAxis,
      
          z: 10,
      
          type: 'category',
      
          data: xAxisData,
      
          axisLabel: {
      
            z: 20,
      
            interval: (index: number) => {
              return index % 2 === 0;
            },
      
            fontSize: 10,
      
            overflow: 'truncate',
      
            width: 80,
      
            color: '#666'
          }
        };
      
        option.angleAxis = {
          ...option.angleAxis,
      
          axisLabel: {
      
            fontSize: 10,
      
            formatter: (value: any) => {
      
              return valueFormatter
                ? valueFormatter(value)
                : value;
            }
          }
        };
      
        option.series = seriesData.map(
          (s: any, i) => ({
      
            ...option.series[0],
      
            z: 2,
      
            type: 'bar',
      
            coordinateSystem: 'polar',
      
            roundCap: false,
      
            barGap: '-100%',
      
            name: s.name,
      
            data: s.data,
      
            itemStyle: {
              borderRadius: 0
            },
      
            emphasis: {
              focus: 'series'
            }
          })
        );
      }

      // ── GAUGE ────────────────────────────────────────────────────────────
      else if (chartType === 'guard_guage') {

        let valueFormatter

            if(this._data?.style.compact?.mode === 'auto' ){

              this._data?.widgetdata?.headers?.forEach(val=>{
                if(val.value === 'metric1'){
                  if(val.type === 'size'){
                    valueFormatter = this.dashboardService.getFormaterSize();
                  }else{
                    valueFormatter = this.dashboardService.getFormaterFunction();
                  }
                }
              })
        
            }else{
              if (this._data?.style?.compact?.type === 'number') {
                valueFormatter = this.dashboardService.getFormaterFunction();
              } else if (this._data?.style?.compact?.type === 'size') {
                valueFormatter = this.dashboardService.getFormaterSize();
              }
            }
      
        const value = getValue(seriesData[0]?.data[0]) || 0;
      
        option.tooltip = {
          trigger: 'item'
        };
      
        option.series = [
          {
            type: 'gauge',
      
            startAngle: 180,
      
            endAngle: 0,
      
            center: ['50%', '75%'],
      
            radius: '120%',
      
            min: 0,
      
            max: 100,
      
            splitNumber: 10,
      
            axisLine: {
              lineStyle: {
                width: 6,
      
                color: [
                  [0.1, '#58D9F9'],
                  [0.5, '#FDDD60'],
                  [1, '#FF6E76']
                ]
              }
            },
      
            pointer: {
      
              icon:
                'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
      
              length: '10%',
      
              width: 10,
      
              offsetCenter: [0, '-60%'],
      
              itemStyle: {
                color: 'auto'
              }
            },
      
            axisTick: {
      
              length: 6,
      
              distance: 3,
      
              lineStyle: {
                color: 'auto',
                width: 1
              }
            },
      
            splitLine: {
      
              length: 12,
      
              distance: 3,
      
              lineStyle: {
                color: 'auto',
                width: 3
              }
            },
      
            axisLabel: {
      
              color: '#464646',
      
              fontSize: 12,
      
              distance: -25,
      
              rotate: 'tangential',
      
              formatter: (v: any) => `${v}`
            },
      
            title: {
      
              offsetCenter: [0, '-1%'],
      
              fontSize: 12
            },
      
            detail: {
      
              fontSize: 20,
      
              offsetCenter: [0, '-25%'],
      
              valueAnimation: true,
      
              formatter: (v: any) => {
                return valueFormatter
                  ? valueFormatter(v)
                  : v;
              },
      
              color: 'inherit'
            },
      
            
            data: [
              {
                name:
                  this._data?.widgetdata?.headers?.find(
                    (m: any) => m.value === seriesData[0]?.name
                  )?.disp ||
                  seriesData[0]?.name ||
                  'Value',
            
                value
              }
            ]
          }
        ];
      }

      // ── SANKEY ───────────────────────────────────────────────────────────
      else if (chartType === 'sankey') {

        const metricKey = metricKeys[0];
      
        const nodes: any[] = [];
      
        const links: any[] = [];
      
        // unique node tracker
        const nodeMap = new Map<string, any>();
      
        rows.forEach((row: any) => {
      
          // create nodes
          dimensionKeys.forEach((dimKey: string, dimIndex: number) => {
      
            const value = row[dimKey];
      
            // SAME value in SAME level => SAME id
            const nodeId = `lvl_${dimIndex}_${value}`;
      
            if (!nodeMap.has(nodeId)) {
      
              const node = {
                id: nodeId,
                name: value
              };
      
              nodeMap.set(nodeId, node);
      
              nodes.push(node);
            }
          });
      
          // create links dynamically
          for (let i = 0; i < dimensionKeys.length - 1; i++) {
      
            const sourceValue = row[dimensionKeys[i]];
      
            const targetValue = row[dimensionKeys[i + 1]];
      
            const sourceId =
              `lvl_${i}_${sourceValue}`;
      
            const targetId =
              `lvl_${i + 1}_${targetValue}`;
      
            links.push({
              source: sourceId,
              target: targetId,
              value: getValue(row[metricKey])
            });
          }
        });
      
        option.series[0].data = nodes;
      
        option.series[0].links = links;
      
        option.series[0].label = {
          formatter: function (node: any) {
            return node.name;
          }
        };
      
        option.series[0].lineStyle = {
          color: 'source'
        };
      
        // ✨ added hover spotlight effect
        option.series[0].emphasis = {
          focus: 'adjacency',
      
          lineStyle: {
            opacity: 0.9
          },
      
          itemStyle: {
            opacity: 1
          },
      
          label: {
            opacity: 1
          }
        };
      
        option.series[0].blur = {
      
          lineStyle: {
            opacity: 0.05
          },
      
          itemStyle: {
            opacity: 0.15
          },
      
          label: {
            opacity: 0.15
          }
        };

        let valueFormatter

            if(this._data?.style.compact?.mode === 'auto' ){

              this._data?.widgetdata?.headers?.forEach(val=>{
                if(val.value === 'metric1'){
                  if(val.type === 'size'){
                    valueFormatter = this.dashboardService.getFormaterSize();
                  }else{
                    valueFormatter = this.dashboardService.getFormaterFunction();
                  }
                }
              })
        
            }else{
              if (this._data?.style?.compact?.type === 'number') {
                valueFormatter = this.dashboardService.getFormaterFunction();
              } else if (this._data?.style?.compact?.type === 'size') {
                valueFormatter = this.dashboardService.getFormaterSize();
              }
            }
      
        option.tooltip = {
          trigger: 'item',
      
          formatter: (params: any) => {
      
            const nodes = option.series[0].data;
      
            const getNodeName = (id: string) => {
      
              const node = nodes.find(
                (n: any) => n.id === id
              );
      
              return node?.name || id;
            };
      
            // edge
            if (
              params.data &&
              params.data.source &&
              params.data.target
            ) {
      
              return `
              
                ${getNodeName(params.data.source)}
                >
                ${getNodeName(params.data.target)} : <strong>${valueFormatter(params.data.value)}</strong>
              `;
            }
      
           // node
            if (!params.data.source && !params.data.target) {

              return `
                ${params.data?.name || params.name}
                : <strong>${valueFormatter(params.value)}</strong>
              `;
            }
          }
        };
      }

      // ── TREEMAP ──────────────────────────────────────────────────────────
      else if (chartType === 'treemap') {

        const rows = this._data?.widgetdata?.rows || [];
      
        const dimensionKeys = Object.keys(rows[0] || {}).filter(
          key => key.startsWith('dimension')
        );
      
        const metricKey = Object.keys(rows[0] || {}).find(
          key => key.startsWith('metric')
        );
      
        const treeMapRoot: any[] = [];
      
        const addToTree = (
          tree: any[],
          dimensions: any[],
          value: number
        ) => {
      
          if (!dimensions.length || !tree) {
            return;
          }
      
          const currentDimension = dimensions[0] ?? 'Unknown';
      
          let existingNode = tree.find(
            (node: any) => node.name === currentDimension
          );
      
          if (!existingNode) {
      
            existingNode = {
              name: currentDimension,
              value: 0,
            };
      
            if (dimensions.length > 1) {
              existingNode.children = [];
            }
      
            tree.push(existingNode);
          }
      
          existingNode.value += value;
      
          if (dimensions.length > 1) {
      
            if (!existingNode.children) {
              existingNode.children = [];
            }
      
            addToTree(
              existingNode.children,
              dimensions.slice(1),
              value
            );
          }
        };
      
        rows.forEach((row: any) => {
      
          const dimensions = dimensionKeys
            .map(key => row[key])
            .filter(v => v !== null && v !== undefined);
      
          if (!dimensions.length) {
            return;
          }
      
          const value = getValue(row[metricKey!]);
      
          addToTree(treeMapRoot, dimensions, value);
      
        });
      
        let valueFormatter

            if(this._data?.style.compact?.mode === 'auto' ){

              this._data?.widgetdata?.headers?.forEach(val=>{
                if(val.value === 'metric1'){
                  if(val.type === 'size'){
                    valueFormatter = this.dashboardService.getFormaterSize();
                  }else{
                    valueFormatter = this.dashboardService.getFormaterFunction();
                  }
                }
              })
        
            }else{
              if (this._data?.style?.compact?.type === 'number') {
                valueFormatter = this.dashboardService.getFormaterFunction();
              } else if (this._data?.style?.compact?.type === 'size') {
                valueFormatter = this.dashboardService.getFormaterSize();
              }
            }
      
          option.tooltip = {

            trigger: 'item',
          
            // backgroundColor: 'white',
          
            // borderColor: '#d8c7c7',
          
            // borderWidth: 1,
          
            // borderRadius: 4,
          
          
            // textStyle: {
            //   color: '#5c5c5c',
              // fontSize: 16,
              // fontWeight: 500
            // },
          
            // extraCssText: `
            //   box-shadow: 0 2px 10px rgba(0,0,0,0.12);
            // `,
          
            formatter: (info: any) => {
          
              const treePath = info.treePathInfo
                .slice(1)
                .map((item: any) => item.name)
                .join('/');
          
              return `
                <div>
          
                  <div style="
                  ">
                    ${treePath}
                  </div>
          
                  <div>
                    ${
                      this._data?.widgetdata?.headers?.find(
                        (h: any) => h.value === metricKey
                      )?.disp || metricKey
                    }:
                    <strong>
                      ${valueFormatter(info.value)}
                    </strong>
                  </div>
          
                </div>
              `;
            }
          };
      
        option.series = [{
          name: 'Origin',
      
          type: 'treemap',
      
          data: treeMapRoot.map((node: any, i: number) => ({
            ...node,
            itemStyle: {
              ...(node.itemStyle || {}),
              color: option.color?.[i % option.color.length]
            }
          })),
      
          left: '0%',
      
          right: '0%',
      
          top: 0,
      
          bottom: 28,
      
          width: '100%',
      
          height: 'calc(100% - 28px)',
      
          roam: true,
      
          nodeClick: 'zoomToNode',
      
          colorMappingBy: 'index',
      
          breadcrumb: {
            show: true,
      
            left: 8,
      
            bottom: 2,
      
            height: 18,
      
            emptyItemWidth: 20,
      
            itemStyle: {
              color: '#F4F4F4',
      
              borderColor: '#b5b1b1',
      
              borderWidth: 1,
      
              textStyle: {
                color: '#666565',
      
                fontSize: 10,
              }
            },
      
            emphasis: {
              itemStyle: {
                color: '#F4F4F4',
      
                borderColor: '#7a7878',
      
                textStyle: {
                  color: '#666565',
      
                  fontSize: 10,
      
                  fontWeight: 'bold'
                }
              }
            }
          },
      
          visibleMin: 10,
      
          label: {
            show: true,
      
            formatter: '{b}',
      
            color: '#fff',
      
            fontSize: 11,
      
            overflow: 'truncate'
          },
      
          itemStyle: {
            borderColor: '#fff'
          },
      
          levels: [
            {
              itemStyle: {
                borderWidth: 5,
                gapWidth: 5,
                borderColor: '#fff'
              }
            },
      
            {
              itemStyle: {
                gapWidth: 1,
                borderColor: '#fff'
              }
            },
      
            {
              colorSaturation: [0.35, 0.5],
      
              itemStyle: {
                gapWidth: 1,
                borderColor: '#fff',
                borderColorSaturation: 0.6
              }
            }
          ]
        }];
      }
      // ── HORIZONTAL BAR ───────────────────────────────────────────────────
      else if (chartType === 'horizontal_bar') {

        const LABEL_LIMIT = 10;
      
        const truncateLabel = (
          value: any
        ) => {
      
          const str = String(value);
      
          return str.length > LABEL_LIMIT
            ? str.slice(0, LABEL_LIMIT) + '...'
            : str;
        };
      
        option.yAxis = {
          ...option.yAxis,
      
          type: 'category',
      
          data: xAxisData,
      
          triggerEvent: true,
      
          axisLabel: {
            hideOverlap: true,
      
            formatter: (value: any) => {
              return truncateLabel(value);
            }
          }
        };
      
        option.tooltip = {
      
          trigger: 'axis',
      
          axisPointer: {
            type: 'shadow'
          },
      
          formatter: (params: any) => {
      
            if (
              !params ||
              !params.length
            ) {
              return '';
            }
      
            const firstParam =
              params[0];
      
            // FULL label here
            const fullLabel =
              firstParam.name;
      
            let html = `
              <div style="
                display:flex;
                flex-direction:column;
                gap:6px;
              ">
      
                <div style="
                  font-weight:600;
                  margin-bottom:4px;
                ">
                  ${fullLabel}
                </div>
            `;
      
            params.forEach(
              (p: any) => {
      
                html += `
                  <div style="
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    gap:10px;
                    white-space:nowrap;
                  ">
      
                    <div style="
                      display:flex;
                      align-items:center;
                      gap:6px;
                    ">
      
                      <span style="
                        width:10px;
                        height:10px;
                        border-radius:50%;
                        background:${p.color};
                        display:inline-block;
                      "></span>
      
                      <span>
                        ${p.seriesName}
                      </span>
      
                    </div>
      
                    <strong>
                      ${p.value}
                    </strong>
      
                  </div>
                `;
              }
            );
      
            html += `</div>`;
      
            return html;
          }
        };
      
        option.series = seriesData.map((s: any) => ({
          ...option.series[0],
      
          name:
            this._data?.style?.axes?.[
              "x-axis"
            ]?.name
              ? this._data.style.axes[
                  "x-axis"
                ].name
              : "",
      
          data: s.data,
        }));
      
        // 👇 show full y-axis label on hover
        this.chartInstance.on('mouseover', (params: any) => {
      
          if (params.componentType === 'yAxis') {
      
            let tooltip =
              document.getElementById(
                'yaxis-hover-tooltip'
              );
      
            if (!tooltip) {
      
              tooltip =
                document.createElement('div');
      
              tooltip.id =
                'yaxis-hover-tooltip';
      
              tooltip.style.position =
                'absolute';
      
              tooltip.style.display =
                'none';
      
              tooltip.style.padding =
                '6px 10px';
      
              tooltip.style.background =
                '#f1f6f8';
      
              tooltip.style.color =
                'black';
      
              tooltip.style.borderRadius =
                '4px';
      
              tooltip.style.fontSize =
                '12px';
      
              tooltip.style.pointerEvents =
                'none';
      
              tooltip.style.zIndex =
                '9999';
      
              tooltip.style.whiteSpace =
                'nowrap';

                tooltip.style['box-shadow'] = '0px 2px 2px rgb(0 0 0 / 25%)';
      
              document.body.appendChild(
                tooltip
              );
            }
      
            tooltip.innerHTML =
              params.value;
      
            tooltip.style.display =
              'block';
      
            tooltip.style.left =
              params.event.event.pageX +
              10 +
              'px';
      
            tooltip.style.top =
              params.event.event.pageY +
              10 +
              'px';
          }
        });
      
        this.chartInstance.on('mouseout', (params: any) => {
      
          if (params.componentType === 'yAxis') {
      
            const tooltip =
              document.getElementById(
                'yaxis-hover-tooltip'
              );
      
            if (tooltip) {
      
              tooltip.style.display =
                'none';
            }
          }
        });
      }

      // ── NIGHTINGALE ──────────────────────────────────────────────────────
      else if (chartType === 'nightingale') {
        option.series[0].data = xAxisData.map((name: string, i: number) => ({
          name,
          value: getValue(seriesData[0]?.data[i]),
        }));
        option.series[0].label = false
      }
      // ── STACKED CHARTS ─────────────────────────────────────────────────────
      else if (chartType === 'bar_stack' ||chartType === 'line_stack' ||chartType === 'area_stack') {
        // console.log(echarts.version);
        const xAxisKey = dimensionKeys[0];

//console.log("Rows ->", rows)
        
      
        // Remaining dimensions become series grouping
        const seriesDimensionKeys =
          dimensionKeys.slice(1);
      
        // X Axis
        const xAxisData = [
          ...new Set(
            rows.map((r: any) => r[xAxisKey])
          )
        ];
      
//console.log("X-Axis data ->",xAxisData)

        option.tooltip = {
          trigger: 'item',
      
          triggerOn: 'mousemove',
      
          axisPointer: {
      
            type:
              chartType === 'bar_stack'
                ? 'shadow'
                : 'line',
      
            snap: true,
      
            triggerTooltip: true
          }
        };
      
        option.grid = {
          left: '4%',
          right: '4%',
          bottom: '4%',
          containLabel: true
        };

      
        option.xAxis = {
          ...option.xAxis,
      
          data: xAxisData,
          // boundaryGap: false,
      
          axisPointer: {
            show: true
          }
        };
      
        option.yAxis = {
          ...option.yAxis,
      
          axisPointer: {
            show: false
          }
        };
      
        // IMPORTANT
        delete option.axisPointer;
      
        const seriesMap = new Map();
      
        rows.forEach((row: any) => {
      
          // Build grouping key
          const dimensionPart =
            seriesDimensionKeys.length
              ? seriesDimensionKeys
                  .map((k: string) => row[k])
                  .join(' - ')
              : 'Series';
      
          metricKeys.forEach(
            (metricKey: string) => {
      
              const seriesKey =
                metricKeys.length > 1
                  ? `${dimensionPart} - ${metricKey}`
                  : dimensionPart;
      
              if (!seriesMap.has(seriesKey)) {
                if (!seriesMap.has(seriesKey)) {

                  const colorPalette =
                    this._data?.style?.color_palette?.length
                      ? this._data.style.color_palette
                      : (option.color || [
                          '#5470c6',
                          '#91cc75',
                          '#fac858',
                          '#ee6666',
                          '#73c0de',
                          '#3ba272',
                          '#fc8452',
                          '#9a60b4',
                          '#ea7ccc'
                        ]);
                
                  const color =
                    colorPalette[seriesMap.size % colorPalette.length];
                
                  seriesMap.set(seriesKey, {
                
                    ...option.series[0],
                
                    name: seriesKey,
                
                    type: option.series[0].type,
                
                    stack: 'Total',
                
                    color: color,
                
                    smooth: chartType === 'area_stack',
                
                    showSymbol:
                      chartType === 'area_stack' ||
                      chartType === 'line_stack',
                
                    symbol:
                      chartType === 'area_stack' ||
                      chartType === 'line_stack'
                        ? 'circle'
                        : 'none',
                
                    symbolSize:
                      chartType === 'area_stack' ||
                      chartType === 'line_stack'
                        ? 4
                        : 0,
                
                    lineStyle: {
                      ...(option.series[0].lineStyle || {}),
                      color: color
                    },

                    areaStyle: chartType === 'area_stack'
                    ? {
                        color,
                        // opacity: 0.4
                      }
                    : undefined,
                
                    emphasis: {
                      focus: 'series',
                      itemStyle: {
                        color: '#fff',
                        borderColor: color,
                        borderWidth:
                          chartType === 'area_stack' ||
                          chartType === 'line_stack'
                            ? 2
                            : 0
                      }
                    },
                
                    blur: {
                      lineStyle: {
                        opacity: 0.15
                      },
                      areaStyle: {
                        opacity: 0.05
                      },
                      itemStyle: {
                        opacity: 0.15
                      }
                    },
                
                    itemStyle: {
                      color: chartType === 'area_stack' ||
                      chartType === 'line_stack' ? '#fff' : color,
                      borderColor: color,
                      borderWidth:
                        chartType === 'area_stack' ||
                        chartType === 'line_stack'
                          ? 2
                          : 0
                    },
                
                    data: new Array(xAxisData.length).fill(0)
                  });
                }
              }
      
              const seriesObj =
                seriesMap.get(seriesKey);
      
              const xIndex =
                xAxisData.indexOf(
                  row[xAxisKey]
                );
      
              seriesObj.data[xIndex] =
                getValue(row[metricKey]);
            }
          );
        });
      
        option.series =
          Array.from(seriesMap.values());

        
      }

      // ── DEFAULT (line, bar, area) ─────────────────────────────────────────
      else {

        if (option.xAxis?.data !== undefined) {
          option.xAxis.data = xAxisData;
        }

        option.series = seriesData.map((s: any) => ({
          ...option.series[0],

          "symbol": "diamond",
          "symbolSize": 5,

          name:
            this._data?.style.axes?.["y-axis"]?.enable
              ? this._data?.style.axes?.["y-axis"]?.name
              : this.chartData.headers.find(
                  (h: any) => h.value === s.name
                )?.disp || s.name,

          ...(chartType === 'area_chart' && {
            lineStyle: {
              // width: 0,
            
            },
            // "symbol": "circle",
            // smooth:true
            // showSymbol: false,
          }),

          data: s.data,
        }));
      }
    }

    // ── FALLBACK (no chartType set) ────────────────────────────────────────
    else {
      const { xAxisData, series: seriesData } = parseTableData();

      option = {
        xAxis: { type: 'category', data: xAxisData },
        yAxis: { type: 'value' },
        series: [
          {
            type: 'bar',
            data: seriesData[0]?.data ?? [],
            name: this._data?.style.axes?.["y-axis"]?.enable ? this._data?.style.axes?.["y-axis"]?.name : ""
          },
        ],
      };
    }



    this.chartInstance.setOption(option, true);
    //     this.chartInstance.setOption({grid: {
    //       top: "4%",
    //       left: "2%",
    //       right: "2%",
    //       bottom: "2%",
    //       containLabel:true
    //     }
    // })
    // this.chartInstance.setOption({
    //   series: option.series.map(() => ({
    //     label: { position: 'inside' }
    //   }))
    // });
    this.chartOptions = this.chartInstance.getOption();
    //console.log('Option =---->', this.chartOptions);

    this.applyStyleToChart(this.chartInstance, this._data.style, this._data?.type)

    // setTimeout(() => {
    //   console.log("Resize on timeout")
    //   this.onResize()
    // }, 1500);
  }

  onOptionsClick(event: MouseEvent): void {
    //console.log('Options clicked', event);
  }

  onResize(): void {
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  }

  openOverlay(origin: any, component, componentInputs, dimensions) {
    this.overlayRef = this.cdkOverlyayService.open({
      data: componentInputs,
      height: dimensions[0],
      width: dimensions[1],
    }, origin, component);
    return this.overlayRef;
  }

  openCharttype(origin) {
    // console.log("Origin =---->",origin)
    this.openOverlay(origin, ChartTypeSelectorComponent,
      "preview", ["50vh", "auto"]
    );

    this.overlayRef.$cube.pipe(takeUntil(this.destroy$))
      .subscribe((chart) => {


        //console.log("Selected Chart =---->",chart)
//console.log("On Chart Preview")
        this.widgetBuilderVarService.selectedChart = chart
        this.chart_type = chart.value
        if (chart.value != 'label' && chart.value != 'table') {
          this.widgetBuilderVarService.chartType = chart.value
          this.widgetBuilderVarService.selectorChart = chart.value
          this.widgetBuilderVarService.styleStruct=this.widgetBuilderVarService.applyStyleValidation(chart.value,this.widgetBuilderVarService.styleValidation,this.widgetBuilderVarService.styleStruct)
          // this._data.type = chart.value
          this.widgetBuilderVarService.refreshChart(true)
        }

      })

  }

  openOverlay_moreoptions_click(template, origin): void {
    let config = {
      data: {

        "template": template,
      }
    }
    this.dialogRef = this.cdkOverlyayService.dashboard_moreoptions(config, TemplateDropdownComponent, origin);
  }


  buildWidgetReqobj(datefilter, timerange,) {
    return {
      "widgetlist": [{
        "widget_id": this.widgetId,
        "platform_id": this.widgetInfo["platform_id"]
      }],
      "time_range": timerange,
      "timezone": this.sharedService.timeZone,
      "date_filter": datefilter,
      "mode": this.dashboardBuilderVarService.dashboard_preview_mode

    }

  }

  getWidgetData(datefilter, timerange) {
    this.isProgress = true;

    this.handledashboardwidgetnodata.resetError()
    this.errorhandledashboardwidget.resetError()
    this.chartData = {}
    let reqobj = this.buildWidgetReqobj(datefilter, timerange)
    this.dashboardBuilderService.dashboardWidgetDataGet(reqobj)
      .pipe(takeUntil(this.destroy$))
      .subscribe((dat: any) => {
        if (dat.hasOwnProperty("isError") && dat["isError"]) {
          this.errorhandledashboardwidget.seterror(true, dat.error?.errmsg);
          this.isProgress = false
          this.cdf.detectChanges()
        } else {
          if (!dat[parseInt(this.widgetId)]["widgetdata"]?.rows?.length) {
            this.handledashboardwidgetnodata.seterror(true, this.sharedService.metaData.alert.noDatamsg[1])
            this.customSubtitle(this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
            this.isProgress = false
            this.cdf.detectChanges()
          } else {
            this.chartData = dat[parseInt(this.widgetId)]["widgetdata"]
            // console.log("CHART DATA =---->",this.chartData )
            this.chartData = this.formatWidgetData(this.chartData)
            this.customSubtitle(this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
            this.chartInstance?.dispose()
            this.isProgress = false
            setTimeout(() => {
              this.initChart()
            }, 0)

            this.cdf.detectChanges()
          }
        }
      })
//console.log("=---->", this.isProgress)
  }

  refreshWidget() {
    if (this.dialogRef) {
      this.dialogRef.close()
    }
    this.resetdateinput()
    this.setTimeRange(this.widgetInfo.time_range)
    this.filterDays = this.widgetInfo.time_range[2]
    this.getWidgetData(false, this.sharedService.getTimerangeFromMetaDate(this.widgetInfo.time_range))
  }

//   formatWidgetData(widgetData: any) {
// //console.log({ widgetData });
  
//     if (!widgetData?.rows || !widgetData?.headers) {
//       return widgetData;
//     }
  
//     // find all timestamp headers
//     const timeHeaders = widgetData?.headers
//       .filter(
//         (h: any) =>
//           h.type?.toLowerCase() === 'timestamp'
//       )
//       .map((h: any) => h.value);
    
  
//     const formattedRows = widgetData?.rows?.map((row: any) => {
//       const updatedRow = { ...row };
  
//       timeHeaders.forEach((key: string) => {
//         const value = updatedRow[key];
  
//         // skip null/undefined
//         if (value === null || value === undefined) return;
  
//         const strValue = String(value);
  
//         // detect hour format like 00,01,02...
//         const isHourFormat = /^(0\d|1\d|2[0-3])$/.test(strValue);
  
//         if (isHourFormat) {
//           // convert to am/pm
//           const h = parseInt(strValue, 10);
  
//           const suffix =
//             h >= 12 ? 'pm' : 'am';
  
//           const hour12 =
//             h % 12 || 12;
  
//           updatedRow[key] = `${hour12}${suffix}`;
//         } else {
//           // treat as epoch
//           const epoch = Number(value);
  
//           if (!isNaN(epoch)) {
//             const date = new Date(
//               strValue.length === 10
//                 ? epoch * 1000
//                 : epoch
//             );
  
//             updatedRow[key] =
//               date.toLocaleDateString(
//                 'en-GB',
//                 {
//                   day: '2-digit',
//                   month: 'short'
//                 }
//               );
//           }
//         }
//       });
  
//       // console.log({ updatedRow });
  
//       return updatedRow;
//     });
  
// //console.log({ formattedRows });
  
//     return {
//       ...widgetData,
//       rows: formattedRows
//     };
//   }

formatWidgetData(widgetData: any, isStacked = false) {
  if (!widgetData?.rows || !widgetData?.headers) {
    return widgetData;
  }

  const timeHeaders = widgetData.headers
    .filter(
      (h: any) =>
        h.type?.toLowerCase() === 'timestamp'
    )
    .map((h: any) => h.value);

  if (!timeHeaders.length) {
    return widgetData;
  }

  let rows = [...widgetData.rows];

  /*
   * For stacked charts:
   * Build a common timestamp order across ALL series.
   *
   * This prevents a missing date in one series from
   * shifting the remaining values out of alignment.
   */
  if (isStacked) {
    const timestampSet = new Set<string>();
  
    rows.forEach((row: any) => {
      timeHeaders.forEach((key: string) => {
        const value = row[key];
  
        if (value !== null && value !== undefined) {
          timestampSet.add(String(value));
        }
      });
    });
  
    const sortedTimestamps = Array.from(timestampSet).sort(
      (a, b) => {
        const getTimestamp = (value: string) => {
          if (/^(0\d|1\d|2[0-3])$/.test(value)) {
            return parseInt(value, 10);
          }
  
          const epoch = Number(value);
  
          if (!isNaN(epoch)) {
            return value.length === 10
              ? epoch * 1000
              : epoch;
          }
  
          return new Date(value).getTime();
        };
  
        return getTimestamp(a) - getTimestamp(b);
      }
    );
  
    const reorderedRows: any[] = [];
  
    sortedTimestamps.forEach((timestamp) => {
      const matchingRows = rows.filter((row: any) =>
        timeHeaders.some(
          (key: string) =>
            String(row[key]) === timestamp
        )
      );
  
      matchingRows.forEach((row: any) => {
        const updatedRow = { ...row };
  
        timeHeaders.forEach((key: string) => {
          if (
            updatedRow[key] === null ||
            updatedRow[key] === undefined
          ) {
            updatedRow[key] = 0;
          }
        });
  
        reorderedRows.push(updatedRow);
      });
    });
  
    rows = reorderedRows;
  }

  const formattedRows = rows.map((row: any) => {
    const updatedRow = { ...row };

    timeHeaders.forEach((key: string) => {
      const value = updatedRow[key];

      // skip null/undefined
      if (value === null || value === undefined) {
        return;
      }

      const strValue = String(value);

      // detect hour format like 00,01,02...
      const isHourFormat =
        /^(0\d|1\d|2[0-3])$/.test(strValue);

      if (isHourFormat) {
        const h = parseInt(strValue, 10);

        const suffix = h >= 12 ? 'pm' : 'am';

        const hour12 = h % 12 || 12;

        updatedRow[key] = `${hour12}${suffix}`;
      } else {
        // treat as epoch
        const epoch = Number(value);

        if (!isNaN(epoch)) {
          const date = new Date(
            strValue.length === 10
              ? epoch * 1000
              : epoch
          );

          updatedRow[key] =
            date.toLocaleDateString(
              'en-GB',
              {
                day: '2-digit',
                month: 'short'
              }
            );
        }
      }
    });

    return updatedRow;
  });

  return {
    ...widgetData,
    rows: formattedRows
  };
}

  dateFilterClick() {
    if (!this.selectTime.errors) {
      if (this.previewRef) {
        this.previewRef.close()
        this.dialogRef.close()
      }
      this.setTimeRange("")
      let time_range = [this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.fromDate.value).format(this.dashboardService.timeformat), this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.toDate.value).format(this.dashboardService.timeformat)]
      this.getWidgetData(true, time_range)
    }
  }

  relativeTimeClick(mode: string, filtervalue: any, timemode: string) {
    if (this.previewRef) {
      this.previewRef.close()
      this.dialogRef.close()
    }
    //console.log("filtervalue===",filtervalue)
    this.resetdateinput()
    this.setTimeRange(filtervalue)
    let timerange = this.sharedService.getTimerangeFromMetaDate(filtervalue)
    this.getWidgetData(true, timerange)
  }

  download_click() {
    if (!this.handledashboardwidgetnodata.status) {
      // this.moreOptionState = false; //close the moreoption div before downloading
      this.cdf.detectChanges(); // it stop executing the next lines untill the change is ddtected
      let DATA: any = document.getElementById('chart' + this.widgetId); //full widget with title and more filter imagej 
      //console.log({DATA},"====getElementById=================",this.widgetId)
      let date = "DATE : " + this.timeZoneService.getcurrentuserTime().format("DD-MM-YYYY") + "\n" + "TIME : " + this.timeZoneService.getcurrentuserTime().format("hh:mm:ss")
      const fileName = this.title + "_" + this.timeZoneService.getcurrentuserTime().format("DDMMYYYY") + ".pdf"

      html2canvas(DATA).then((canvas) => {
        let fileWidth = 200;
        let fileHeight = (canvas.height * fileWidth) / canvas.width;
        const FILEURI = canvas.toDataURL('image/png');
        let PDF = new jsPDF('p', 'mm', 'a4');
        PDF.addFileToVFS('Metropolis-ExtraLight.ttf', Metropolis_ExtraLight);
        PDF.addFileToVFS('Metropolis-Light.ttf', Metropolis_Light);
        PDF.addFileToVFS('Metropolis-LightItalic.ttf', Metropolis_LightItalic);
        PDF.addFileToVFS('Metropolis-Medium.ttf', Metropolis_Medium);
        PDF.addFileToVFS('Metropolis-Regular.ttf', Metropolis_Regular);
        PDF.addFileToVFS('Metropolis-SemiBold.ttf', Metropolis_SemiBold);
        PDF.addFont('Metropolis-Regular.ttf', 'metropolis', 'normal');
        PDF.addFont('Metropolis-Light.ttf', 'metropolis', 'light');
        PDF.addFont('Metropolis-SemiBold.ttf', 'metropolis', 'bold');
        PDF.setFontSize(15)
        PDF.setTextColor('#0A4143')
        PDF.setFont('metropolis', 'normal')
        PDF.text(this.title, 9, 20)
        PDF.setFontSize(9)
        PDF.setTextColor('#0A4143')
        PDF.setFont('metropolis', 'light')
        // PDF.text(this.widgetDetail.timeRange[0]+' - '+this.widgetDetail.timeRange[1],6,25)
        PDF.text(this.subtitle, 10, 25)
        PDF.setFontSize(9)
        PDF.setTextColor('#0A4143')
        PDF.setFont('metropolis', 'normal')
        PDF.text(date, 170, 20)
        let position = 50;
        PDF.addImage(FILEURI, 'PNG', 5, position, fileWidth, fileHeight);
        PDF.save(fileName);
      });
    }
  }

  closeOptions_click() {
    if (this.dialogRef) {
      this.dialogRef.close()
    }
  }

  colorPalatte_click(index, selectedColor) {
//console.log(index,selectedColor)
    this.selectedColorIndex = index
    // if (this.chartInstance) {
    //   //console.log("Color ")
    //   this.chartInstance.setOption({
    //     color: selectedColor
    //   });

    //   //console.log(this.chartInstance.getOption())
    //   this.chartOptions = this.chartInstance.getOption()
    // }

    if (this.chartInstance) {
       
        
      if (this._data.type === 'polar_radial_bar' || this._data.type ===  'polar_tangential_bar') {
        

//console.log(this._data.type , "POLAR")

        const option = this.chartInstance.getOption();
      
        option.series[0].data = option.series[0].data.map((d: any, i: number) => {
      
          // if data is primitive number
          if (typeof d === 'number') {
            return {
              value: d,
              itemStyle: {
                color: selectedColor[i % selectedColor.length]
              }
            };
          }
      
          // if already object
          return {
            ...d,
            itemStyle: {
              ...(d.itemStyle || {}),
              color: selectedColor[i % selectedColor.length]
            }
          };
      
        });
      
        this.chartInstance.setOption(option);
      }
      else if(this._data.type === 'heatmap' || this._data.type === 'polar_heatmap'){

        const option = this.chartInstance.getOption();
        option.visualMap = {
         
          inRange: {
            color : selectedColor
          }
        };
        this.chartInstance.setOption(option);
      }
      else if (this._data.type === 'treemap') {

        const option = this.chartInstance.getOption();
      
        const palette = selectedColor;
      
        option.series[0].data = option.series[0].data.map((node, i) => ({
          ...node,
          itemStyle: {
            ...(node.itemStyle || {}),
            color: palette[i % palette.length]
          }
        }));
      
        this.chartInstance.setOption(option);
      
      }
      else if(this._data.type == 'guard_guage'){

//console.log("Guard Guage")
      
        const colors = selectedColor;
      
        const option = this.chartInstance.getOption();
      
        option.series[0].axisLine.lineStyle.color = [
          [0.1, colors[0] || '#58D9F9'],
          [0.5, colors[1] || '#FDDD60'],
          [1, colors[2] || '#FF6E76']
        ];
      
        option.series[0].title.color =
          colors[3] || '#464646';
      
        option.series[0].axisLabel.color =
          colors[3] || '#464646';
      
        option.series[0].detail.color =
          colors[3] || '#464646';
      
        this.chartInstance.setOption(option);
      }
      else if(this._data.type == 'line_stack' || this._data.type == 'area_stack' || this._data.type == 'bar_stack' || this.widgetBuilderVarService.chartType == 'area_stack'){
//console.log("AREA STACK")
          
                    const option = this.chartInstance.getOption();
                  
                    option.color = selectedColor;
                  
                    option.series.forEach((series: any, index: number) => {
                  
                      const color = selectedColor[index % selectedColor.length];
                  
                      series.color = color;
                  
                      series.lineStyle = {
                        ...(series.lineStyle || {}),
                        color
                      };
                      if(this._data.type == 'area_stack' || this.widgetBuilderVarService.chartType == 'area_stack'){
//console.log("AREA")
                        series.areaStyle =  {
                          color: color,
                          // opacity: 0.4
                        
                        }
                        series.itemStyle = {
                          ...(series.itemStyle || {}),
                          color: '#fff',
                          borderColor: color,
                          borderWidth: 2
                        };
                    
                        series.emphasis = {
                          ...(series.emphasis || {}),
                          itemStyle: {
                            ...(series.emphasis?.itemStyle || {}),
                            color: '#fff',
                            borderColor: color,
                            borderWidth: 2
                          }
                        };
                      }else if(this.widgetBuilderVarService.chartType == 'line_stack'){
                        delete series.areaStyle;
                      }
                      else {
        //console.log("NOT AREA")
                          delete series.areaStyle;
                          series.itemStyle={
                            color: color
                          }
                      }
                  
                     
                    });
                  
                    this.chartInstance.setOption(option,true);
//console.log(this.chartInstance.getOption())
                  
                }
    else{
      this.chartInstance.setOption({
        color: selectedColor
      });
    
    }
    this.chartOptions = this.chartInstance.getOption();
  }


  }

  open_overlay(template: any, origin: any,) {
    let config = {
      // width: '5%',
      // backdropClass: 'cdk-overlay-dark-backdrop',
      data: {

        "template": template,
      }
    }
    this.previewRef = this.cdkOverlyayService.openPreview(config, TemplateDropdownComponent, origin);


    this.previewRef.$closed.subscribe(() => {

    })
  }

  openOverlay_templateRef(template: any, origin: any, overlaytype: any): void {
    this.open_overlay(template, origin)
  }

  fullscreen_click(header, subheader, body): void {
    if (!this.handledashboardwidgetnodata.status) {
      this.matDialog.open(DialogBoxComponent, {
        width: '60%',
        height: '80vh',
        data: {
          template: body,
          head: header,
          subHead: subheader,
        }
      });
    }
  }

  resetdateinput() {
    this.selectTime.controls.fromDate.reset(this.defaultTimeRange.from);
    this.selectTime.controls.toDate.reset(this.defaultTimeRange.to);
  }


  setTimeRange(noOfDays: any) {
    if (noOfDays && noOfDays[2] >= 0) {
      this.filterDays = noOfDays[2];
      this.timeRange.controls.fromDate.patchValue(this.sharedService.calculate_timerange(noOfDays)[0]);
      this.timeRange.controls.toDate.patchValue(this.sharedService.calculate_timerange(noOfDays)[1]);
    } else {
      this.filterDays = undefined;
      this.timeRange.controls.fromDate.patchValue(this.timeZoneService.setcurrentuserTime(this.selectTime.controls.fromDate.value).format('YYYY-MM-DD'));
      this.timeRange.controls.toDate.patchValue(this.timeZoneService.setcurrentuserTime(this.selectTime.controls.toDate.value).format('YYYY-MM-DD'));
    }
  }


  customSubtitle(fromdate, todate, numDays) {
    let sub = ""
    let format = 'D MMM'
    switch (true) {
      case (numDays == undefined || (fromdate && todate)):
        this.subtitle = sub + ` ` + `custom   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
        break;
      case (numDays == 1):
        this.subtitle = sub + ` ` + ` yesterday` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
        break;
      case (numDays == 0):
        this.subtitle = sub + ` ` + ` today` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
        break;
      default:
        this.subtitle = sub + ` ` + ` past ${numDays + 1} days` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
    }
  }



  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}



